'use client';

import React from 'react';
import ActivitySuccessContent from './ActivitySuccessContent';
import ActivitySuccessNonProfitBar from './ActivitySuccessNonProfitBar';
import ActivitySuccessDonateLoggedOut from './ActivitySuccessDonateLoggedOut';
import { useRouter } from 'next/navigation';

const donationMessageTemplates = [
  'Just donated to [Nonprofit Name] and feeling grateful to give back—every bit counts toward a brighter future!',
  'I made a difference today by supporting [Nonprofit Name]. Join me in spreading kindness!',
  'Proud to support [Nonprofit Name]—small acts can lead to big changes.🌍❤️#GiveBack',
  'Helping [Nonprofit Name] with a donation today! Every step toward change starts with us ⭐#BeTheChange',
  'Feeling grateful to contribute to [Nonprofit Cause] through [Nonprofit Name]. Together, we can make a real impact!',
  'Supporting a cause close to my heart today—[Nonprofit Name] is doing amazing work!💙#MakeADifference',
  'Donated to [Nonprofit Name] and feeling inspired. If you’re able, let’s create change together!',
  'A little goes a long way! Just gave to [Nonprofit Name] and it feels so good. #GivingBack',
  'Today, I chose kindness. Proud to support [Nonprofit Name] in their incredible work!',
  'Doing my part to support [Nonprofit Name] today! Every donation counts toward hope and healing. #SpreadGoodness',
];

function ActivitySuccessDialog(props) {
  const {
    user = null,
    post = null,
    reward = null,
    message = null,
    company = null,
    donate = false,
    isPost = false,
    nonProfit = null,
    donateType = null,
    originPage = null,
    isLoggedIn = false,
    isPostPublic = false,
    supportedNonProfit = null,
    onClose,
  } = props;

  const router = useRouter();

  const handleDonateRedirect = () => {
    router.push('/home');
  };

  const handleOnContinue = () => {
    if (
      !message &&
      donate &&
      !['gift-of-giving', 'user-external-donation'].includes(donateType)
    ) {
      return handleDonateRedirect();
    }
    onClose();
  };

  return (
    <div className="w-full">
      <ActivitySuccessNonProfitBar
        nonProfit={nonProfit}
        company={company}
        user={user}
        isPost={isPost}
        donate={donate}
        supportedNonProfit={supportedNonProfit}
      />
      {donate && !isLoggedIn ? (
        <ActivitySuccessDonateLoggedOut
          user={user}
          reward={reward}
          donate={donate}
          donateType={donateType}
          originPage={originPage}
          hasUserSession={isLoggedIn}
          onContinue={handleOnContinue}
          nonProfit={nonProfit || supportedNonProfit}
          donationMessageTemplates={donationMessageTemplates}
        />
      ) : (
        <ActivitySuccessContent
          user={user}
          post={post}
          isPost={isPost}
          reward={reward}
          donate={donate}
          message={message}
          donateType={donateType}
          isPostPublic={isPostPublic}
          onContinue={handleOnContinue}
          hasUserSession={isLoggedIn || user?.id > 0}
          nonProfit={nonProfit || supportedNonProfit}
          donationMessageTemplates={donationMessageTemplates}
        />
      )}
    </div>
  );
}

export default ActivitySuccessDialog;
